const axios = require('axios').default;

export default async function PostOrder(entry) {
  let form_data = new FormData;
  form_data.append('athletes', JSON.stringify(entry.selected));
  form_data.append('wager', entry.wager);
  form_data.append('payout', entry.payout);
  form_data.append('isH2H', entry.isH2H);
  form_data.append('h2hPayout', entry.h2hPayout);
  form_data.append('opponentOid', entry.opponentOid);
  form_data.append('multiplierType', entry.multiplierType);
  form_data.append('action', 'create_order');
  return await axios.post('/wp-admin/admin-ajax.php', form_data).then(response => {
    return response.data;
  });
}
